import config from '../config';
import { EventEmitter } from 'events';
import Api from '../api/api';
import { includes, get } from 'lodash';
import { GET_BANNER_DATA_COMMAND } from '../api/appBannerApi';

const LOGOUT_EVENT = 'LOGOUT_EVENT';

export class LogoutTimeoutInterceptorService {

  /** @type {LogoutTimeoutInterceptorService} */
  static instance;

  static getInstance() {
    if (!LogoutTimeoutInterceptorService.instance) {
      LogoutTimeoutInterceptorService.instance = new LogoutTimeoutInterceptorService();
    }
    return LogoutTimeoutInterceptorService.instance;
  }

  static destroy() {
    if (!LogoutTimeoutInterceptorService.instance) {
      return;
    }
    const service = LogoutTimeoutInterceptorService.getInstance();
    service.dispose();
    LogoutTimeoutInterceptorService.instance = null;
  }

  set timeout(duration) {
    this._duration = duration;
    this.resetTimeout();
  }

  _duration = config.getSessionLifetime();
  _timeoutId = null;
  _eventEmitter = new EventEmitter();

  constructor() {
    this.init();
  }

  init = async () => {
    await config.configPromise;
    this.timeout = config.getSessionLifetime();
    Api.addInterceptor(this.resetTimeout);
  }

  dispose = () => {
    this._clearLogoutTimeout();
    this.removeLogoutEvents();
    Api.removeInterceptor(this.resetTimeout);
  }

  registerLogoutEvent = (cb) => {
    this._eventEmitter.on(LOGOUT_EVENT, cb);
  }

  removeLogoutEvents = () => {
    this._eventEmitter.removeAllListeners();
  }

  resetTimeout = (xhr, settings) => {
    if(includes(get(settings,'data'), GET_BANNER_DATA_COMMAND )) {
      return null
    }
    else {
      this._clearLogoutTimeout();
      this._setLogoutTimeout()
    }
  }

  _setLogoutTimeout = () => {
    this._timeoutId = window.setTimeout(this._emit, this._duration);
  }

  _clearLogoutTimeout = () => {
    window.clearTimeout(this._timeoutId);
    this._timeoutId = null;
  }

  _emit = () => {
    this._eventEmitter.emit(LOGOUT_EVENT);
  }

}
